<template>
  <div class="zwx-scrollbar-y">
    <el-scrollbar class="zwx-scrollbar-box-y" ref="scrollbarY">
      <slot />
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  name: 'ZwxScrollbarY',
  data() {
    return {
      top: 0,
    }
  },
  mounted() {
    this.$refs.scrollbarY.$refs.wrap.onscroll = this.scroll
  },
  activated() {
    this.scrollTop(this.top)
  },
  methods: {
    scroll() {
      this.$zwxCookie.addCookie('nothingDoingTime', Date.now().toString())
      this.top = this.$refs.scrollbarY.wrap.scrollTop
      this.$emit('scrollTop', this.top)
    },
    scrollTop(top) {
      this.$nextTick(() => {
        if (top < 0) {
          this.$refs.scrollbarY.moveY = 0
          this.$refs.scrollbarY.wrap.scrollTop = 0
        } else {
          this.$refs.scrollbarY.wrap.scrollTop = top
        }
      })
    },
    getTop() {
      return this.top
    },
  },
}
</script>

<style lang="less" scoped>
.zwx-scrollbar-y > .zwx-scrollbar-box-y {
  height: 100% !important;
}
</style>

<style lang="less">
.zwx-scrollbar-y > .zwx-scrollbar-box-y > .el-scrollbar__wrap {
  overflow: scroll !important;
  height: 100% !important;
  overflow-x: hidden !important;
  margin-bottom: 0 !important;
}

.zwx-scrollbar-y > .zwx-scrollbar-box-y > .el-scrollbar__bar.is-vertical {
  width: 8px !important;
  z-index: 99 !important;
  pointer-events: none !important;
}

.zwx-scrollbar-y > .zwx-scrollbar-box-y > .el-scrollbar__bar.is-horizontal {
  display: none !important;
  pointer-events: none !important;
}

.zwx-scrollbar-y > .zwx-scrollbar-box-y .el-scrollbar__thumb {
  border-radius: 3px !important;
  background-color: #d8d8d8 !important;
  cursor: default !important;
  pointer-events: auto !important;
}

.zwx-scrollbar-y > .zwx-scrollbar-box-y .el-scrollbar__thumb:hover,
.zwx-scrollbar-y > .zwx-scrollbar-box-y .el-scrollbar__thumb:active {
  background-color: #b3b3b3 !important;
}
</style>
